<div [formGroup]="form" class="form-item-card card border form-modal rounded-3">
  <div class="card-header bg-white">
    <div class="fs-6 fw-bold m-0 d-flex gap-2 align-items-center">
      <app-icon [size]="26" [strokeWidth]="2" color="#ce343c" name="user-star"></app-icon>
      Persona que desea asegurar
    </div>
  </div>
  <div class="card-body pt-2 p-3">
    <div class="row g-3 row-cols-1 row-cols-md-2">
      <div class="col">
        <label class="form-label small fw-semibold text-muted text-uppercase uppercase"
          for="insuranceItemBirthDateInsured">Fecha de nacimiento / asegurado
          principal</label>
        <app-datepicker-input id="insuranceItemBirthDateInsured" formControlName="birthDate"
          [control]="form.get('birthDate')" inputClass="form-control py-2 focus-ring fw-bold focus-ring-success"
          [errorMessages]="{
            required: 'La fecha de nacimiento del asegurado principal es obligatoria',
            invalidBirthDate: 'Fecha no válida',
            minAge: 'El asegurado principal debe tener al menos ' + option.minAge + ' años',
            maxAge: 'El asegurado principal debe tener como máximo ' + option.maxAge + ' años'
          }"></app-datepicker-input>
      </div>
      <div class="col">
        <div class="form-label small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Sexo / asegurado
          principal</div>
        <div class="d-flex gap-2">
          <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
            <input [value]="Gender.F" class="form-check-input focus-ring focus-ring-success"
              formControlName="primaryGender" id="insuranceSex1" type="radio">
            <label class="form-check-label fw-bold" for="insuranceSex1">Femenino</label>
          </div>
          <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
            <input [value]="Gender.M" class="form-check-input focus-ring focus-ring-success"
              formControlName="primaryGender" id="insuranceSex2" type="radio">
            <label class="form-check-label fw-bold" for="insuranceSex2">Masculino</label>
          </div>
        </div>
        @if (form.get('primaryGender')?.touched && form.get('primaryGender')?.hasError('required')) {
        <div class="text-danger small mt-1">Debe seleccionar el sexo del asegurado principal.</div>
        }
      </div>
    </div>
    <div class="row g-3 row-cols-1 row-cols-md-2 pt-2">
      <div class="col">
        <label class="form-label small fw-semibold text-muted text-uppercase uppercase">Estatura / asegurado
          principal</label>
        <div class="d-flex gap-2">
          <div class="form-floating flex-fill">
            <input class="form-control fw-bold" formControlName="heightFeet" id="insuranceHeightFeet" max="8" min="0"
              placeholder="Pies" type="number">
            <label class="text-uppercase fw-semibold small" for="insuranceHeightFeet">Pies</label>
          </div>
          <div class="form-floating flex-fill">
            <input class="form-control fw-bold" formControlName="heightInches" id="insuranceHeightInches" max="11"
              min="0" placeholder="Pulgadas" type="number">
            <label class="text-uppercase fw-semibold small" for="insuranceHeightInches">Pulgadas</label>
          </div>
        </div>
        @if ((form.get('heightFeet')?.touched || form.get('heightInches')?.touched) &&
        (form.get('heightFeet')?.hasError('required') || form.get('heightInches')?.hasError('required'))) {
        <div class="text-danger small mt-1">La estatura del asegurado principal es obligatoria</div>
        }
      </div>
      <div class="col">
        <label class="form-label small fw-semibold text-muted text-uppercase uppercase"
          for="insuranceWeight">Peso / asegurado principal</label>
        <div class="d-flex gap-2 align-items-center">
          <div class="form-floating flex-fill">
            <input class="form-control fw-bold" formControlName="weight" id="insuranceWeight" min="1"
              placeholder="Peso" type="number">
            <label class="text-uppercase fw-semibold small" for="insuranceWeight">Peso</label>
          </div>
          <div class="d-flex gap-2 py-2">
            <div class="form-check form-check-inline align-items-end d-flex gap-2">
              <input class="form-check-input" formControlName="weightUnit" id="insuranceWeightUnitKg" type="radio"
                value="kg">
              <label class="form-check-label fw-bold" for="insuranceWeightUnitKg">Kg</label>
            </div>
            <div class="form-check form-check-inline align-items-end d-flex gap-2">
              <input class="form-check-input" formControlName="weightUnit" id="insuranceWeightUnitLb" type="radio"
                value="lb">
              <label class="form-check-label fw-bold" for="insuranceWeightUnitLb">Lb</label>
            </div>
          </div>
        </div>
        @if (form.get('weight')?.touched && form.get('weight')?.hasError('required')) {
        <div class="text-danger small mt-1">El peso del asegurado principal es obligatorio</div>
        }
      </div>
      @if (bmiExceedsMax) {
      <div class="col-12">
        <div class="text-danger small mt-1">
          El Índice de Masa Corporal (IMC: {{ bmiValue | number: '1.1-1' }}) supera el máximo permitido. No es
          posible continuar con esta solicitud.
        </div>
      </div>
      }
    </div>
    @if (option.requiresOccupation) {
    <div class="row g-3 pt-2">
      <div class="col-12">
        <label class="form-label mb-0 small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Ocupación
          / asegurado principal</label>
        <select aria-label="Ocupación de asegurado" class="form-select fw-bold py-2 focus-ring focus-ring-success"
          formControlName="occupationCode" sharedFormInput>
          <option [ngValue]="null">Elige una ocupación</option>
          @for (occ of occupations; track occ) {
          <option [ngValue]="occ.occupationCode">{{ occ.occupationDescription }}</option>
          }
        </select>
      </div>
    </div>
    }
    @if (option.familyAllowed) {
    <div class="row border-top pt-3 mt-3">
      <div class="col-12">
        <div class="form-label small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Agrega asegurados
          secundarios</div>
        <div class="d-flex gap-2">
          <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
            <input class="form-check-input focus-ring focus-ring-success" formControlName="spouseIncluded"
              id="insuranceDependent1" sharedFormInput type="checkbox" value="Cónyugue">
            <label class="form-check-label fw-bold" for="insuranceDependent1">Cónyugue</label>
          </div>
          <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
            <input class="form-check-input focus-ring focus-ring-success" formControlName="childrenEnabled"
              id="insuranceDependent2" sharedFormInput type="checkbox" value="Hijos">
            <label class="form-check-label fw-bold" for="insuranceDependent2">Hijos</label>
          </div>
          <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
            <input class="form-check-input focus-ring focus-ring-success" formControlName="othersEnabled"
              id="insuranceDependent3" sharedFormInput type="checkbox" value="Otros">
            <label class="form-check-label fw-bold" for="insuranceDependent3">Otros</label>
          </div>
        </div>
      </div>
    </div>
    }
    @if (option.familyAllowed && form.get('spouseIncluded')?.value) {
    <div class="row g-3 border-top py-3 mt-3">
      <div class="col-12 col-md-4">
        <label class="form-label small fw-semibold text-muted text-uppercase uppercase"
          for="insuranceItemBirthDateSpouse">Fecha de nacimiento del
          Cónyugue</label>
        <app-datepicker-input id="insuranceItemBirthDateSpouse" formControlName="spouseBirthDate"
          [control]="form.get('spouseBirthDate')" inputClass="form-control py-2 focus-ring fw-bold focus-ring-success"
          [errorMessages]="{
                              required: 'La fecha de nacimiento del cónyuge es obligatoria',
                              invalidBirthDate: 'Fecha no válida',
                              minAge: 'El cónyuge debe tener al menos ' + (option.minAge != null && option.minAge > 18 ? option.minAge : 18) + ' años',
                              maxAge: 'El cónyuge debe tener como máximo ' + option.maxAge + ' años'
                            }"></app-datepicker-input>
      </div>
      <div class="col">
        <div class="form-label small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Sexo de Cónyugue
        </div>
        <div class="d-flex gap-2">
          <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
            <input [value]="Gender.F" class="form-check-input focus-ring focus-ring-success"
              formControlName="spouseGender" id="insuranceSexSpouse1" type="radio">
            <label class="form-check-label fw-bold" for="insuranceSexSpouse1">Femenino</label>
          </div>
          <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
            <input [value]="Gender.M" class="form-check-input focus-ring focus-ring-success"
              formControlName="spouseGender" id="insuranceSexSpouse2" type="radio">
            <label class="form-check-label fw-bold" for="insuranceSexSpouse2">Masculino</label>
          </div>
        </div>
        @if (form.get('spouseGender')?.touched && form.get('spouseGender')?.hasError('required')) {
        <div class="text-danger small mt-1">Debe seleccionar el sexo del cónyuge.</div>
        }
      </div>
    </div>
    }
    <ng-content></ng-content>
  </div>
</div>